module.exports = __webpack_public_path__ + "static/media/contact.abfc345b.png";